module.exports = __webpack_public_path__ + "static/media/background.454002b7.jpg";